<template>
  <v-dialog persistent max-width="290" v-model="showDataLoading">
    <v-card color="primary" dark>
      <v-card-text class="pt-5">
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        loadingMessages: [
          'Reticulating splines...',
          'Generating witty dialog...',
          'Swapping time and space...',
          'Spinning violently around the y-axis...',
          'Tokenizing real life...',
          'Bending the spoon...'
        ]
      };
    },
    computed: {
      ...mapState(['app', 'navigation', 'configurator']),
      /**
       * Determines whether the data is currently being loaded.
       * Returns true if any of the following conditions are met:
       * - The configurator is validating a component.
       * - The configurator is refreshing the tree summary data.
       * - The configurator is loading subsystem steps and no subsystem step is loaded
       * - The configurator is loading a step component.
       *
       * @returns {boolean} True if the data is currently being loaded, otherwise false.
       */
      showDataLoading() {
        return (
          (this.configurator.isValidatingComponent ||
            this.configurator.isLoadingStepComponent ||
            this.configurator.isLoadingSubsystem ||
            this.configurator.isLoadingSystem ||
            (this.configurator.isLoadingSubsystemSteps && this.configurator.currentSubsystemStepComponent == null)) &&
          !this.app.sig.show
        );
      }
    }
  };
</script>
